import { Component, OnInit } from '@angular/core'
import { fuseAnimations } from '../../../core/animations'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { FuseConfigService } from '../../../core/services/config.service'
import { AuthService } from '../../../auth.service'
import { Router, ActivatedRoute } from '@angular/router'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { pinLoginDutch } from './i18n/nl'
import { pinLoginEnglish } from './i18n/en'
import { DeviceModel } from '../models/device.model'
import { DeviceService } from '../service/device.service'

@Component({
  selector: 'fuse-pincode',
  templateUrl: './pinlogin.component.html',
  styleUrls: ['./pinlogin.component.scss'],
  animations: fuseAnimations,
})
export class PinloginComponent implements OnInit {
  pinForm: FormGroup
  loginFormErrors: any
  returnUrl: string
  device: DeviceModel
  isLoading = false

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fuseConfig: FuseConfigService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private deviceService: DeviceService,
    private translationLoader: FuseTranslationLoaderService,
  ) {
    this.translationLoader.loadTranslations(pinLoginDutch, pinLoginEnglish)

    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none',
        toolbar: 'none',
        footer: 'none',
      },
    })

    this.loginFormErrors = {
      login: {},
    }
  }

  ngOnInit() {
    this.pinForm = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(5)]],
    })

    this.returnUrl = localStorage.getItem('redirect') || '/administrations'
    this.device = JSON.parse(localStorage.getItem('device'))
  }

  onLogin() {
    const code = this.pinForm.get('code').value
    this.isLoading = true
    this.deviceService.validateDevice(code, this.device.device_id).subscribe(
      validate => {
        this.authService.twoFactor(this.device).subscribe(token => {
          this.isLoading = false
          this.authService.onLoggedIn(token)
          this.router.navigateByUrl(this.returnUrl)
        })
      },
      error => {
        this.loginFormErrors.login.failed = true
      },
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/2fa/pinlogin.component.ts